import { stopRecording } from '@/apis';
import { decodeEncryptedURL, errorToString, gibberish, logErrorApi } from '@/utils/common';
import { useEffect } from 'react';
import { useLoaderData, useNavigate, useRouteError } from 'react-router-dom';
import { toast } from 'react-toastify';

const ErrorBoundary = ({ classError }: { classError?: string }) => {
  const data = useLoaderData();
  const error = useRouteError();
  const navigate = useNavigate();

  useEffect(() => {
    if (!classError) {
      console.error('new error', error);

      let roomId = '0',
        userId = '0';

      if (window.location.href.includes('/class/')) {
        let [, dataString] = window.location.href.split(gibberish);
        dataString = decodeEncryptedURL(dataString);
        if (dataString.length > 0) {
          const [data] = dataString.split('?');
          [roomId, userId] = data.split('_');
        }
      }
      logErrorApi(
        parseInt(roomId as string) || 0,
        1,
        userId || '-',
        'Runtime error in error boundary',
        `${(error as ErrorEvent)?.message} ${window.location.href} ${!error ? '' : typeof error === 'object' ? errorToString(error || {}) : JSON.stringify(error)}`
      );

      if (data?.isRecorder) {
        const retry = localStorage.getItem('error-retry');
        if (!retry) {
          localStorage.setItem('error-retry', 'retry');
          setTimeout(() => {
            window.location.reload();
          }, 2000);
          return;
        }
        if (data?.isAdmin) {
          localStorage.removeItem('bot-entry');
          navigate('/over');
        } else {
          localStorage.removeItem('error-retry');
          stopRecording(data?.roomId || parseInt(roomId as string) || 0).catch((error) =>
            logErrorApi(
              parseInt(roomId as string) || 0,
              1,
              userId || '-',
              'ERROR: STOP RECORDING API FAIL',
              error.message
            ).catch((error) =>
              toast('error sending logs' + ' ' + error.message + ' ' + JSON.stringify(error))
            )
          );
        }
      }
    }
  }, [classError, data?.isAdmin, data?.isRecorder, data?.roomId, error, navigate]);

  return (
    <>
      <div className="sticky top-0 left-0 z-10 flex w-full items-center justify-center gap-4 bg-blue-500 p-2 dark:bg-slate-900">
        <img className="h-10" src="/images/ad_logo.webp" />
        <div className="text-xl font-semibold text-white">Crystal</div>
      </div>
      <div className="flex h-[calc(100dvh-56px)] flex-col items-center justify-center gap-4">
        <div className="text-6xl font-bold">{':('}</div>
        <div className="text-xl font-bold md:text-2xl">
          {classError ||
            ((data as { message?: string })?.message?.includes(
              'Classroom joining link got expired for userId'
            )
              ? 'Your live class preview has ended.'
              : 'Oops! An error has occured')}
        </div>
        {!classError && (
          <button
            className="rounded-lg bg-blue-500 p-2 text-white transition-colors hover:bg-blue-500/80"
            onClick={() => window.location.reload()}
          >
            Refresh
          </button>
        )}
      </div>
    </>
  );
};
export default ErrorBoundary;
